




































import { Component, Vue } from 'vue-property-decorator';
import { Mutation, Action, State } from 'vuex-class';
import ActivityIndicator from '@/components/ActivityIndicator.vue';

import api from '@/api';
import { ApiResponse } from 'apisauce';
import { User } from '@/types';

@Component({
  components: { ActivityIndicator },
})
export default class LogIn extends Vue {
  @State public user!: User;
  @Mutation public SET_HEADER_VISIBILITY: any;
  @Mutation public UPDATE_SOCKET_PLAYER: any;
  @Action public INIT_SOCKET: any;

  public email = '';
  public password = '';

  public formLoading = false;
  public apiError: string | null = null;

  public mounted() {
    this.apiError = null;
    this.SET_HEADER_VISIBILITY(false);
  }
  public destroyed() {
    this.SET_HEADER_VISIBILITY(true);
  }
  public onSubmit() {
    const { email, password } = this;

    this.formLoading = true;
    this.apiError = null;

    // request creation of new JWT token
    api.post('/auth', { email, password })
    .then((res: ApiResponse<any>) => {
      const body = res.data;

      if (res.ok) {
        if (!res.headers) return;
        const headers: any = {...res.headers};
        const JWT = headers.authorization;

        localStorage.setItem('grandquest:jwt', JWT);

        this.INIT_SOCKET();

        this.$router.push('/forum');
      } else {
        this.apiError = body.errors
          ? body.errors.join(', ') + '.'
          : 'Failed to communicate with our servers. Please try again later';
      }

      this.formLoading = false;
    });
  }
}
